import { render, staticRenderFns } from "./myGift.vue?vue&type=template&id=9fbe06ba"
import script from "./myGift.vue?vue&type=script&lang=js"
export * from "./myGift.vue?vue&type=script&lang=js"
import style0 from "./myGift.vue?vue&type=style&index=0&id=9fbe06ba&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports